import "./Disc.scss";
// import nimg from "./img/noimage.png";
import dimg1 from "./img/Church's Blow.jpg";
import dimg2 from "./img/DESPERADO.png";
import dimg3 from "./img/RUN.jpg";
import dimg4 from "./img/honno.jpg";
import dimg5 from "./img/monndainai.png";
import dimg6 from "./img/TRACKFIELD_pic_.JPG";

const Disc = () => {
  const discItem = [
    {
      img: dimg6,
      type: "DJ MEEK feat.Church橋本&Yuji Kato a.k.aパトレイバー",
      title: "TRACK AND FIELD ",
      date: "2023.01.11",
      url: "https://linkco.re/7Tpz0hNg?lang=ja",
      caption: "",
    },
    {
      img: dimg5,
      type: "4th Single",
      title: "問題ない(Free Download)",
      date: "2022.12.25",
      url: "https://www.dropbox.com/s/yf553qx444h4gak/%E5%95%8F%E9%A1%8C%E3%81%AA%E3%81%84.wav?dl=0",
      caption: "",
    },
    {
      img: dimg4,
      type: "3rd Single",
      title: "honno",
      date: "2022.09.03",
      url: "https://linkco.re/rva3PhTV",
      caption: "",
    },
    {
      img: dimg3,
      type: "2nd Single",
      title: "RUN",
      date: "2022.06.18",
      url: "https://linkco.re/1mV6bQxu",
      caption: "",
    },
    {
      img: dimg2,
      type: "1st Single",
      title: "DESPERADO",
      date: "2022.06.01",
      url: "https://big-up.style/YEmIdE6ov0",
      caption: "",
    },
    {
      img: dimg1,
      type: "1st EP",
      title: "Church's Blow",
      date: "2021.08.14",
      url: "https://linkco.re/1FX7sUax",
      caption: "",
    },
  ];

  return (
    <div className="Disc-container-main">
      <div className="Disc-title">
        <h2 id="Disc" className="index">
          Disc
        </h2>
      </div>
      <div className="Disc-wrapper">
        <div className="Disc-item">
          <ul>
            {discItem.map((discItem) => (
              <li>
                <button>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={discItem.url}
                  >
                    {" "}
                    <img src={discItem.img} alt="" />
                  </a>
                </button>
                <div className="Disc-item-caption">
                  <p>{discItem.date}</p>
                  <p>{discItem.type}</p>
                  <p className="Discname">{discItem.title}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Disc;
